import request from '@/utils/request'

// 獲取
export function patientInfo(query) {
  return request({
    url: '/api/patients/patientInfo',
    method: 'get',
    params: query
  })
}

// 新增
export function createPatient(data) {
  return request({
    url: '/api/patients/patientInfo',
    method: 'post',
    data
  })
}
// 修改
export function updatePatient(data) {
  return request({
    url: '/api/patients/patientInfo',
    method: 'put',
    data
  })
}

export function deletePatient(id) {
  return request({
    url: '/api/patients/patientInfo/' + id,
    method: 'delete'
  })
}

export function countPatient(query) {
  return request({
    url: '/api/patients/countPatient',
    method: 'get',
    params: query
  })
}
